module.exports = __webpack_public_path__ + "static/media/wizard_blank_thumbnail.5156abef.png";